export default __webpack_public_path__ + "static/media/yacht_example.508070cd.jpeg";